import { render, staticRenderFns } from "./TextValidator.vue?vue&type=template&id=f5f6eb7e&scoped=true&"
import script from "./TextValidator.vue?vue&type=script&lang=js&"
export * from "./TextValidator.vue?vue&type=script&lang=js&"
import style0 from "./TextValidator.vue?vue&type=style&index=0&id=f5f6eb7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f6eb7e",
  null
  
)

export default component.exports